import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AbiService } from './services/abi.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ethdapp';
  displayedImageGrupo176 = 'assets//img/Grupo_176.png' //
  displayedImageGrupo176Logo = 'assets//img/Grupo_1762x.png'
  displayedImageGrupo84 = 'assets//img/Grupo_84.png'
  displayedImageGrupo86 = 'assets//img/Grupo_86.png'

  constructor(public abiService: AbiService) {
    // console.log('contract', environment.contractAddress)
  }


  async ngOnInit(): Promise<void> {
    // const r = await this.abiService.parseABI("/assets/abi/Lands.json")
    // console.log(r)
}

}
